import eclipse from '../../assets/eclipse.svg';
import styles from './index.module.css';
import { useTranslation } from 'react-i18next';

interface Props {
  message: string;
}

const EclipseLoader: React.FC<Props> = ({ message }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.LoadingPage}>
      <img className={styles.Loader} src={eclipse} alt={t('loading')} />
      <div className={styles.LoadingMessage}>
        {message.split('\n').map((msg, i) => (
          <span key={i}>
            {msg}
            <br />
          </span>
        ))}
      </div>
    </div>
  );
};

export default EclipseLoader;
